<template>
  <div>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      /
      <router-link :to="{ name: 'admin-import' }" class="root">
        Admin Import
      </router-link>
      <span class="child">/Import Subject Registration</span>
    </v-row>
    <div class="mx-auto container container--fluid">
      <br />
      <!-- <span>
          <v-btn color="blue" dark class="mb-2" :loading="isLoading" v-on="on" @click="synchsubjectregistration()" style="margin:2px;float:right;">Synchronization Student subject Registration from ERP</v-btn>
      </span> -->


      <span>
        <v-btn color="blue" dark class="mb-2" :loading="isLoading" v-on="on" @click="synchsubjectregistrationdialog()" style="margin:2px;float:right;">Synchronization Student subject Registration from ERP</v-btn>
    </span>
      <br>
      <br>
      <v-card class="card">
        <v-app id="inspire" class>
          <v-snackbar
            v-model="snackbar"
            :top="true"
            :color="color"
            :timeout="6000"
          >
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-card-title class="heading"
            >Import Subject Registration</v-card-title
          >
          <v-card class="box">
            <div class="flex">
              <div></div>
              <div>
                <a
                  href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/Import_Students_Registration.csv"
                >
                  <v-btn
                    :loading="loading3"
                    :disabled="loading3"
                    color="success"
                    class="ma-2 white--text downbtn"
                    @click="loader = 'loading3'"
                  >
                    <v-icon left dark>mdi-cloud-download</v-icon>
                    Download import CSV format
                  </v-btn>
                </a>
              </div>
            </div>
            <v-card-text>
              <v-row>
                <v-col cols="12" lg="4" sm="12">
                  <v-file-input
                    dense
                    accept=".csv"
                    v-model="file"
                    :hint="file != null ? '' : 'Please Select File'"
                    persistent-hint
                    color="rgb(1, 127, 152)"
                    label="Choose File"
                    prepend-icon="mdi-paperclip"
                    outlined
                    :show-size="1000"
                  >
                  </v-file-input>
                </v-col>
                <v-col cols="4"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4">
                  <center>
                    <v-btn
                      @click="submitFile"
                      :loading="output_load"
                      class="button"
                    >
                      Upload
                      <v-icon right>mdi-cloud-upload</v-icon>
                    </v-btn>
                  </center>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <template v-if="load == true">
            <v-data-table
            :headers="headers"
              v-model="selected"
                         class="nowrap" :items="courseofferinglearner_list1" :search="search"
                         @current-items="getFiltered"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <download-excel
                    :data="filterArr"
                    :fields="table_fields"
                    worksheet="Subject_Reg_Import"
                    name="Subject_Reg_Import.xls"
                  >
                    <v-btn class="ma-1 white--text" color="green">
                      <v-icon dark>
                        mdi-file-excel-box
                      </v-icon>
                      Export to Excel
                    </v-btn>
                  </download-excel>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-btn class="button" @click="dialog_add = true">
                    <v-icon left>mdi-account-plus</v-icon>Add New Subject
                    Registration
                  </v-btn>
                  <v-dialog v-model="dialog_add" max-width="700px">
                    <v-card>
                      <v-card-title class="heading">
                        <span>Add New Subject Registration</span>
                      </v-card-title>
                      <v-card-text>
                        <v-form ref="form">
                          <v-container>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <!-- <v-text-field  v-model.trim="savedata.grno" label="Registration No"></v-text-field> -->
                                <v-text-field
                                  v-model.trim="savedata.grno"
                                  label="Seat Number"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="ay_list"
                                  v-model="savedata.ay"
                                  item-value="ay_id"
                                  item-text="ay_name"
                                  label="Select Acadmic Year"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="course_list"
                                  v-model="savedata.course"
                                  item-value="c_id"
                                  item-text="c_name"
                                  label="Select Course"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="sem_list"
                                  v-model="savedata.sem"
                                  item-value="s_id"
                                  item-text="s_name"
                                  label="Select Semester"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="pattern_list"
                                  v-model="savedata.pattern"
                                  item-value="ptt_id"
                                  item-text="ptt_name"
                                  label="Select Pattern"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="year_list"
                                  v-model="savedata.year"
                                  item-value="y_id"
                                  item-text="y_name"
                                  label="Select Year"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="program_list"
                                  v-model="savedata.program"
                                  item-value="p_id"
                                  item-text="p_name"
                                  label="Select Program"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="program_type_list"
                                  v-model="savedata.program_type"
                                  item-value="pt_id"
                                  item-text="pt_name"
                                  label="Select Program Type"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="registrationtype_list"
                                  v-model="savedata.reg_type"
                                  item-value="rt_id"
                                  item-text="rt_name"
                                  label="Select Registration Type"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                              <v-autocomplete
                                  :items="division_list"
                                  v-model="savedata.division"
                                  item-value="d_id"
                                  item-text="d_name"
                                  label="Select Division"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-checkbox
                                  label="IsActive"
                                  v-model="savedata.is_active"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button-cancel" text @click="closeadd()"
                          >Cancel</v-btn
                        >
                        <v-btn class="button" text @click="adddata">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>





                  <!-- syncdialog starts -->





                  <v-dialog v-model="syncdialog" max-width="700px">
                    <v-card>
                      <v-card-title class="heading">
                        <span>Sync Student Subject Registration</span>
                      </v-card-title>
                      <v-card-text>
                        <v-form ref="form">
                          <v-container>
                            <v-row>
                              
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="ay_list"
                                  v-model="savedata.ay"
                                  item-value="ay_id"
                                  item-text="ay_name"
                                  label="Select Acadmic Year"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="sem_list"
                                  v-model="savedata.sem"
                                  item-value="s_id"
                                  item-text="s_name"
                                  label="Select Semester"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            
                            
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="program_list"
                                  v-model="savedata.program"
                                  item-value="p_id"
                                  item-text="p_name"
                                  label="Select Program"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="program_type_list"
                                  v-model="savedata.program_type"
                                  item-value="pt_id"
                                  item-text="pt_name"
                                  label="Select Program Type"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            
                            <v-row>
                             
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="year_list"
                                  v-model="savedata.year"
                                  item-value="y_id"
                                  item-text="y_name"
                                  label="Select Year"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button-cancel" text @click="closeadd()"
                          >Cancel</v-btn
                        >
                        <v-btn class="button" text @click="synchsubjectregistration()">Sync Data</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>








                   <!-- syncdialog ends -->

                  <!-- Edit -->
                  <v-dialog v-model="dialog_edit" max-width="700px">
                    <v-card>
                      <v-card-title class="heading">
                        <span>Edit Subject Registration</span>
                      </v-card-title>
                      <v-card-text>
                        <v-form ref="form">
                          <v-container>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <!-- <v-text-field v-model.trim="editdata.grno"  label="Registration No"></v-text-field> -->
                                <v-text-field
                                  v-model.trim="editdata.grno"
                                  label="Seat Number"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="ay_list"
                                  v-model="editdata.ay"
                                  item-value="ay_id"
                                  item-text="ay_name"
                                  label="Select Acadmic Year"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="course_list"
                                  v-model="editdata.course"
                                  item-value="c_id"
                                  item-text="c_name"
                                  label="Select Course"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="sem_list"
                                  v-model="editdata.sem"
                                  item-value="s_id"
                                  item-text="s_name"
                                  label="Select Semester"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="pattern_list"
                                  v-model="editdata.pattern"
                                  item-value="ptt_id"
                                  item-text="ptt_name"
                                  label="Select Pattern"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="year_list"
                                  v-model="editdata.year"
                                  item-value="y_id"
                                  item-text="y_name"
                                  label="Select Year"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="program_list"
                                  v-model="editdata.program"
                                  item-value="p_id"
                                  item-text="p_name"
                                  label="Select Program"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="program_type_list"
                                  v-model="editdata.program_type"
                                  item-value="pt_id"
                                  item-text="pt_name"
                                  label="Select Program Type"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="registrationtype_list"
                                  v-model="editdata.reg_type"
                                  item-value="rt_id"
                                  item-text="rt_name"
                                  label="Select Registration Type"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <v-autocomplete
                                  :items="division_list"
                                  v-model="editdata.division"
                                  item-value="d_id"
                                  item-text="d_name"
                                  label="Select Division"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                xs="12"
                                sm="12"
                                lg="6"
                                xl="6"
                                md="12"
                                cols="12"
                              >
                                <input type="hidden" v-model="editdata.r_id" />
                                <v-checkbox
                                  label="IsActive"
                                  v-model="editdata.is_active"
                                ></v-checkbox>
                              </v-col>
                            </v-row>                            
                          </v-container>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button-cancel" text @click="closeedit()"
                          >Cancel</v-btn
                        >
                        <v-btn class="button" text @click="saveedit"
                          >Save</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                  <tr class="t-row">
                        <div>
                            <th class="d-flex">
                                <span v-for="header in headers" :key="header.text">
                                   <span v-if="filters.hasOwnProperty(header.value)">
                                    <v-autocomplete class="mr-5" flat hide-details small dense outlined :label="header.text" multiple clearable :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                                   </span>
                                   
                                </span>
                              
                            </th>
                        </div>
                    </tr>
              </template>
              <template v-slot:item.isactive="{ item }">
                <span v-if="item.isactive">
                  <v-icon color="success" class="mr-2"
                    >mdi-check-circle-outline</v-icon
                  >
                </span>
                <span v-else>
                  <v-icon color="error" class="mr-2"
                    >mdi-close-circle-outline</v-icon
                  >
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-avatar size="33" class="edit-avatar">
                  <v-icon
                    color="rgb(1, 127, 152)"
                    size="18"
                    @click="ass_edit_data(item)"
                    >mdi-pencil</v-icon
                  >
                </v-avatar>
              </template>
            </v-data-table>
          </template>
        </v-app>
      </v-card>
      <v-dialog v-model="dialog_send" hide-overlay persistent width="300">
        <v-card color="#4CAF50" dark>
          <v-card-text>
            "Please wait... while file is uploding !!"
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <br />
      <v-row justify="center">
        <v-dialog
          v-model="dialog_faildata"
          fullscreen
          hide-overlay  
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar class="heading">
              <v-btn icon dark @click="dialog_faildata = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title style="color:#FFF;">Student Import Status</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <download-excel
                    style="margin-top:10px;"
                  :data="failstudentlist"
                  :fields="table_"
                  worksheet="Subject_Reg_Not_Import"
                  name="Subject_Reg_Not_ImportData.xls"
                >
                  <v-btn class="ma-1 white--text" color="green">
                    <v-icon dark>
                      mdi-file-excel-box
                    </v-icon>
                    Export to Fail Excel
                  </v-btn>
                </download-excel>
                <v-btn dark text @click="dialog_faildata = false">
                  Close
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
              <v-row>
                <v-col xs="12" sm="12" lg="6" xl="6" md="12" cols="12">
                  <v-card>
                    <v-card-title>Fail Student Record</v-card-title>
                      <v-card-text v-if="failstudentlist.length!=0">
                        <v-simple-table fixed-header height="800px">
                            <template>
                              <thead>
                                <tr color="red">
                                  <th class="text-left">Sr.NO</th>
                                  <th class="text-left">Registration_Number</th>
                                  <th class="text-left">Course Code</th>
                                  <th class="text-left">Registration Type</th>
                                  <th class="text-left">Academic Year</th>
                                  <th class="text-left">Semester</th>
                                  <th class="text-left">Pattern</th>
                                  <th class="text-left">Program</th>
                                  <th class="text-left">Program Type</th>
                                  <th class="text-left">Year</th>
                                  <th class="text-left">Division</th>
                                  <th class="text-left">Remark</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in failstudentlist" :key="item">
                                  <td style="color:red;">{{ item.srno }}</td>
                                  <td style="color:red;">{{ item.studentgrno }}</td>
                                  <td style="color:red;">{{ item.subject }}</td>
                                  <td style="color:red;">{{ item.rgtype }}</td>
                                  <td style="color:red;">{{ item.ay }}</td>
                                  <td style="color:red;">{{ item.sem }}</td>
                                  <td style="color:red;">{{ item.patt }}</td>
                                  <td style="color:red;">{{ item.pro }}</td>
                                  <td style="color:red;">{{ item.pt }}</td>
                                  <td style="color:red;">{{ item.year }}</td>
                                  <td style="color:red;">{{ item.division }}</td>
                                  <td style="color:red;">{{ item.reason }} - Data is missing</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                      </v-card-text>
                  </v-card>
                </v-col>
                <v-col xs="12" sm="12" lg="6" xl="6" md="12" cols="12">
                  <v-card>
                    <v-card-title>Exist Student Record</v-card-title>
                      <v-card-text v-if="existstudentlist.length!=0"> 
                        <v-simple-table fixed-header height="800px">
                            <template>
                              <thead>
                                <tr color="red">
                                  <th class="text-left">Sr.NO</th>
                                  <th class="text-left">Registration_Number</th>
                                  <th class="text-left">Course Code</th>
                                  <th class="text-left">Registration Type</th>
                                  <th class="text-left">Academic Year</th>
                                  <th class="text-left">Semester</th>
                                  <th class="text-left">Pattern</th>
                                  <th class="text-left">Program</th>
                                  <th class="text-left">Program Type</th>
                                  <th class="text-left">Year</th>
                                  <th class="text-left">Division</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in existstudentlist" :key="item">
                                  <td style="color:green;">{{ item.srno }}</td>
                                  <td style="color:green;">{{ item.studentgrno }}</td>
                                  <td style="color:green;">{{ item.subject }}</td>
                                  <td style="color:green;">{{ item.rgtype }}</td>
                                  <td style="color:green;">{{ item.ay }}</td>
                                  <td style="color:green;">{{ item.sem }}</td>
                                  <td style="color:green;">{{ item.patt }}</td>
                                  <td style="color:green;">{{ item.pro }}</td>
                                  <td style="color:green;">{{ item.pt }}</td>
                                  <td style="color:green;">{{ item.year }}</td>
                                  <td style="color:green;">{{ item.division }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                      </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
    <div class="text-center">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
export default {
  data: () => ({
    table_: {
    Registration_Number:"studentgrno",
    Course_Code:"subject",
    Registration_Type:"rgtype",
    Academic_Year:"ay",
    Semester:"sem",
    Pattern:"patt",
    Program:"pro",
    Program_Type:"pt",
    Year:"years",
    Remark:"reason",
    },
    overlay: false,
    savedata: {
      grno: null,
      ay: null,
      course: null,
      sem: null,
      pattern: null,
      year: null,
      program: null,
      program_type: null,
      reg_type: null,
      division: null,
      is_active: true,
    },
    editdata: {
      grno: null,
      ay: null,
      course: null,
      sem: null,
      pattern: null,
      year: null,
      program: null,
      program_type: null,
      reg_type: null,
      division: null,
      is_active: null,
      r_id: null,
    },
    dialog_add: false,
    dialog_edit: false,
    errorMsg: {
      course_code: false,
      registrationtype: false,
      ay: false,
      sem: false,
    },
    dialog_faildata: false,
    dialog_send: false,
    file: null,
    loading3: false,
    tempname: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    isLoading:false,
    search: "",
    org: null,
    load: false,
    dialog: false,
    courseoff_learner_list: null,
    learner_list: null,
    registrationtype_list: null,
    division_list: null,
    ay_list: null,
    sem_list: null,
    course_list: null,
    pattern_list: null,
    program_list: null,
    program_type_list: null,
    year_list: null,
    failstudentlist: 0,
    existstudentlist: 0,
    syncdialog:false,
    selected: [],
     filterArr: [],
    headers: [
      {
        text: "Sr.NO",
        value: "srno",
      },
      {
        text: "Course",
        value: "course_code",
      },
      {
        text: "Learner",
        value: "grno",
      },
      {
        text: "Seat No.",
        value: "seatno",
      },
      {
        text: "Academic Year",
        value: "ay",
      },
      {
        text: "Semester",
        value: "sem",
      },
      {
        text: "Registration Type",
        value: "registrationtype",
      },
      {
        text: "Division",
        value: "division",
      },
      {
        text: "Active",
        value: "isactive",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
      },
    ],
     filters: {
                course_code: [],
                grno: [],
                seatno: [],
                ay: [],
                sem: [],
               division:[]
            },
    table_fields: {
      Course: "course_code",
      "Seat No": "seatno",
      Learner: "grno",
      "Academic Year": "ay",
      Semester: "sem",
      "Registration Type": "registrationtype",
    },

    editedIndex: -1,
    editedItem: {
      id: "",
      course_code: "",
      registrationtype: "",
      isactive: true,
      grno: "",
      ay: "",
      sem: "",
    },
    defaultItem: {
      id: "",
      course_code: "",
      registrationtype: "",
      isactive: true,
      grno: "",
      ay: "",
      sem: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Subject" : "Edit Subject";
    },
     courseofferinglearner_list1() {
               return this.courseofferinglearner_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.onload();
  },

  methods: {
               getFiltered(e) {
                console.log(e);
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.courseofferinglearner_list.map((d) => d[val]);
            },
        //     synchsubjectregistration()
        // {
        // this.isLoading = true;
        // axios
        //     .post("/Erpsynch/synchSubjectRegistration")
        //     .then((res) => {
        //         if (res.data.status == "200") {
        //             this.showSnackbar("#4caf50", "Student Subject Registration Synchronized Successfully..!"); 
        //             this.isLoading = false;
        //         } else if (res.data.status.code == "NA") {
        //             this.showSnackbar("#b71c1c", "Error While Synchronization"); 
        //             this.isLoading = false;
        //         }
        //         else{
        //             this.showSnackbar("#b71c1c", "Error While Synchronization"); 
        //             this.isLoading = false;
        //         }
        //     })
        //     .catch((error) => {
        //         window.console.log(error);
        //         this.isLoading = false;
        //     });
        // },





        synchsubjectregistration()
        {
        this.isLoading = true;
        let formData = new FormData();
         formData.append("ay", this.savedata.ay);
         formData.append("sem", this.savedata.sem);
         formData.append("program", this.savedata.program);
         formData.append("programtype", this.savedata.program_type);
         formData.append("year", this.savedata.year);
        axios
            .post("/Erpsynch/synchSubjectRegistration",formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },} )
            .then((res) => {
                if (res.data.status == "200") {
                    this.showSnackbar("#4caf50", "Student Subject Registration Synchronized Successfully..!"); 
                    this.isLoading = false;
                } else if (res.data.status.code == "NA") {
                    this.showSnackbar("#b71c1c", "Error While Synchronization"); 
                    this.isLoading = false;
                }
                else{
                    this.showSnackbar("#b71c1c", "Error While Synchronization"); 
                    this.isLoading = false;
                }
            })
            .catch((error) => {
                window.console.log(error);
                this.isLoading = false;
            });
        },



    onload() {
      //alert("Onload")
      this.overlay = true;
      axios
        .post("/Examination/importSubjectRegistrationHome")
        .then((res) => {
          //alert(res.data.msg)
          if (res.data.msg == "200") {
            this.courseofferinglearner_list =
              res.data.courseofferinglearner_list;
            this.learner_list = res.data.learner_list;
            this.courseoff_learner_list = res.data.courseoff_learner_list;
            this.registrationtype_list = res.data.reg_type;
            this.ay_list = res.data.aylist;
            this.sem_list = res.data.semlist;
            this.org = res.data.org;
            this.course_list = res.data.courselist;
            this.pattern_list = res.data.patternlist;
            this.program_list = res.data.program_list;
            this.program_type_list = res.data.programType_list;
            this.year_list = res.data.yearlsit;
            this.division_list = res.data.division_list;
            this.load = true;
            this.overlay = false;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },

    synchsubjectregistrationdialog(){
      this.syncdialog=true;
    },
    closeadd() {
      //alert("close"+this.savedata.ay)
      this.dialog_add = false;
      this.syncdialog=false;
    },
    closeedit() {
      //alert("close"+this.savedata.ay)
      this.dialog_edit = false;
    },
    adddata() {
      if (this.savedata.grno == null) {
        this.showSnackbar("#b71c1c", "Enter Student Registration Number !");
      } else if (this.savedata.ay == null) {
        this.showSnackbar("#b71c1c", "Select Acadmic Year!");
      } else if (this.savedata.course == null) {
        this.showSnackbar("#b71c1c", "Select Course !");
      } else if (this.savedata.sem == null) {
        this.showSnackbar("#b71c1c", "Select Semester !");
      } else if (this.savedata.pattern == null) {
        this.showSnackbar("#b71c1c", "Select Pattern !");
      } else if (this.savedata.year == null) {
        this.showSnackbar("#b71c1c", "Select Year !");
      } else if (this.savedata.program == null) {
        this.showSnackbar("#b71c1c", "Select Program !");
      } else if (this.savedata.program_type == null) {
        this.showSnackbar("#b71c1c", "Select Program Type !");
      } else if (this.savedata.reg_type == null) {
        this.showSnackbar("#b71c1c", "Select Registration Type!");
      } else {
        //alert("savedata")
        const data = {
          grno: this.savedata.grno,
          ay: this.savedata.ay,
          course: this.savedata.course,
          sem: this.savedata.sem,
          pattern: this.savedata.pattern,
          year: this.savedata.year,
          program: this.savedata.program,
          program_type: this.savedata.program_type,
          reg_type: this.savedata.reg_type,
          division: this.savedata.division,
          isactive: this.savedata.is_active,
        };
        axios
          .post("/Examination/saveSubjectRegistration", data)
          .then((res) => {
            //alert(res.data.status.code)
            if (res.data.msg == "200") {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar("#4CAF50", res.data.status.message);
                this.dialog_add = false;
                this.onload();
              } else {
                this.showSnackbar("#b71c1c", res.data.status.message);
                this.dialog_add = false;
              }
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong");
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
    },
    ass_edit_data(item) {
      //alert("edit"+item.seatno)

      this.editdata.r_id = item.id;
      this.editdata.grno = item.seatno;
      this.editdata.ay = item.ayid;
      this.editdata.course = item.cid;
      this.editdata.sem = item.semid;
      this.editdata.pattern = item.pattid;
      this.editdata.year = item.yid;
      this.editdata.program = item.pid;
      this.editdata.program_type = item.ptid;
      this.editdata.reg_type = item.registrationtypeid;
      this.editdata.division = item.divisionid;
      this.editdata.is_active = item.isactive;

      this.dialog_edit = true;
    },
    saveedit() {
      //alert("saveedit")
      if (this.editdata.grno == null) {
        this.showSnackbar("#b71c1c", "Enter Student Registration Number !");
      } else if (this.editdata.ay == null) {
        this.showSnackbar("#b71c1c", "Select Acadmic Year!");
      } else if (this.editdata.course == null) {
        this.showSnackbar("#b71c1c", "Select Course !");
      } else if (this.editdata.sem == null) {
        this.showSnackbar("#b71c1c", "Select Semester !");
      } else if (this.editdata.pattern == null) {
        this.showSnackbar("#b71c1c", "Select Pattern !");
      } else if (this.editdata.year == null) {
        this.showSnackbar("#b71c1c", "Select Year !");
      } else if (this.editdata.program == null) {
        this.showSnackbar("#b71c1c", "Select Program !");
      } else if (this.editdata.program_type == null) {
        this.showSnackbar("#b71c1c", "Select Program Type !");
      } else if (this.editdata.reg_type == null) {
        this.showSnackbar("#b71c1c", "Select Registration Type!");
      } else {
        //alert("savedata")
        const data = {
          grno: this.editdata.grno,
          ay: this.editdata.ay,
          course: this.editdata.course,
          sem: this.editdata.sem,
          pattern: this.editdata.pattern,
          year: this.editdata.year,
          program: this.editdata.program,
          program_type: this.editdata.program_type,
          reg_type: this.editdata.reg_type,
          division: this.editdata.division,
          isactive: this.editdata.is_active,
          id: this.editdata.r_id,
        };
        axios
          .post("/Examination/editSubjectRegistration", data)
          .then((res) => {
            //alert(res.data.msg)
            if (res.data.msg == "200") {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar("#4CAF50", res.data.status.message);
                this.dialog_edit = false;
                this.onload();
              } else {
                this.showSnackbar("#b71c1c", res.data.status.message);
                this.dialog_edit = false;
              }
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong");
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
    },

    submitFile() {
      if (this.file == null) {
        this.showSnackbar("#b71c1c", "Please select the file!");
        //alert("Please select the file!");
      } else {
        this.output_load = true;
        this.dialog_send = true;
        let formData = new FormData();
        //console.log(this.file.size)
        formData.append("file", this.file);

        //console.log(formData)
        axios
          .post("Examination/importStudentregistration", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            //  alert("msg::"+res.data.msg)
            if (res.data.msg == "200") {
              //this.courseofferinglearner_list = res.data.courseofferinglearner_list;
              this.load = false;
              this.dialog_send = false;
              this.failstudentlist = res.data.failstatuslist;
              this.existstudentlist = res.data.existstatuslist;
              //alert(this.failstudentlist.length +' : '+this.existstudentlist.length)
              if (this.failstudentlist.length != 0 || this.existstudentlist.length != 0) {
                this.showSnackbar(
                  "#4CAF50",
                  "Partially Subject Import Successfully !!"
                );
                 this.file=null
                 this.onload()
                this.dialog_faildata = true;
              } else {
                this.file=null
                this.showSnackbar("#4CAF50", "Subject Import Successfully !!");
                this.dialog_faildata = false;
                this.onload()
              }
              this.onload();
            } else {
              this.dialog_send = false;
              this.showSnackbar(
                "#b71c1c",
                "Something went wrong Or Data Entered is not Available...!!!"
              );
            }
          })
          .catch(function() {
            console.log("FAILURE!!");
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    }, //end of the fuction

    initializeErrorMsgFalse() {
      this.errorMsg.course_code = false;
      this.errorMsg.registrationtype = false;
      this.errorMsg.ay = false;
      this.errorMsg.sem = false;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      this.editedIndex = this.courseofferinglearner_list.indexOf(item);
      //this.editedIndex = this.course_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      // this.$refs.form.reset()
    },
    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Examination/editSubjectRegistration", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.courseofferinglearner_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar("#4caf50", "Subject Updated Successfully..."); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        if (this.isValidated()) {
          axios
            .post("/Examination/saveSubjectRegistration", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                this.courseofferinglearner_list.push(this.editedItem);
                this.onload();
                this.showSnackbar(
                  "#4caf50",
                  " Subject Registration Added Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", " Learner Not Found..!!!"); // show snackbar on error
              }
            })
            .catch((error) => {});

          this.close();
        }
      }
      // this.editedItem = "";
    }, // end of save()

    isValidated() {
      if (
        this.editedItem.course_code &&
        this.editedItem.registrationtype &&
        this.editedItem.ay &&
        this.editedItem.sem
      ) {
        return true;
      } else {
        if (!this.editedItem.course_code) {
          this.errorMsg.course_code = true;
        }
        if (!this.editedItem.registrationtype) {
          this.errorMsg.registrationtype = true;
        }
        if (!this.editedItem.ay) {
          this.errorMsg.ay = true;
        }
        if (!this.editedItem.sem) {
          this.errorMsg.sem = true;
        }

        return false;
      }
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.downbtn {
  float: right;
}

.elevation-1 /deep/ thead {
  background: lightgray !important;
}

.elevation-1 /deep/ table {
  border: 1px solid lightgray;
}
.box {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 600px) {
  .flex {
    display: block;
  }
}
</style>
